import './styles/globals.css'
import '@repo/ui/fonts'

import { scrubPii } from '@repo/pii-scrubber'
import * as Sentry from '@sentry/react'
import { QueryClientProvider } from '@tanstack/react-query'
import { RouterProvider } from '@tanstack/react-router'
import React from 'react'
import ReactDOM from 'react-dom/client'

import { Toaster } from '@/components/ui/sonner'

import { installChunkReloadGuard } from './lib/chunk-reload'
import { isHandledApiError } from './lib/error-messages'
import { queryClient, router } from './router'

installChunkReloadGuard()

Sentry.init({
  dsn: import.meta.env.VITE_SENTRY_DSN,
  enabled: import.meta.env.PROD && Boolean(import.meta.env.VITE_SENTRY_DSN),
  environment: 'production',
  // Não reporta erros esperados/tratados (com mensagem amigável no toast). Erros
  // inesperados — 5xx, falha de rede, JS, ou 4xx com código desconhecido — seguem.
  beforeSend(event, hint) {
    if (isHandledApiError(hint?.originalException)) return null
    return scrubPii(event)
  },
})

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <Sentry.ErrorBoundary
      fallback={<p>Algo deu errado. Recarregue a página.</p>}
    >
      <QueryClientProvider client={queryClient}>
        <RouterProvider router={router} />
        <Toaster position="top-right" />
      </QueryClientProvider>
    </Sentry.ErrorBoundary>
  </React.StrictMode>
)
